export const totalOffset = (node, offset = 0) =>
  offset + (node ? node?.offsetTop + totalOffset(node?.offsetParent) : 0);

export const refTotalOffset = (nodeRef, offset = 0) =>
  totalOffset(nodeRef?.current, offset);

export const height = (node) => node?.clientHeight || 0;

export const refHeight = (nodeRef) => height(nodeRef?.current);
